import { PaginationTableOffersType } from '../types/MovimentacaoFundosType';

export const renderButtons = (dataPagination) => {
  const buttons = [];

  if (dataPagination.totalPages <= 5) {
    Array.from({ length: dataPagination.totalPages }, (_, i) => i + 1).forEach(
      (page) => {
        buttons.push(
          <button
            key={page}
            data-testid={page}
            className={`tw-w-10 tw-h-10 ttw-focus:outline-none tw-focus:shadow-outline  tw-rounded-md ${
              dataPagination.currentPage === page
                ? 'tw-bg-[#FA6B25] tw-text-white'
                : 'tw-bg-white tw-text-blue-900'
            }`}
            onClick={() => dataPagination.handlePageClick(page)}
          >
            {page}
          </button>
        );
      }
    );
  } else {
    if (dataPagination.currentPage <= 3) {
      Array.from({ length: 5 }, (_, i) => i + 1).forEach((i) => {
        buttons.push(
          <button
            key={i}
            data-testid={i}
            className={`tw-w-10 tw-h-10 ttw-focus:outline-none tw-focus:shadow-outline  tw-rounded-md ${
              dataPagination.currentPage === i
                ? 'tw-bg-[#FA6B25] tw-text-white'
                : 'tw-bg-white tw-text-blue-900'
            }`}
            onClick={() => dataPagination.handlePageClick(i)}
          >
            {i}
          </button>
        );
      });

      buttons.push(<span key="ellipsis">...</span>);
    } else if (dataPagination.currentPage >= dataPagination.totalPages - 2) {
      buttons.push(<span key="ellipsis">...</span>);

      Array.from(
        { length: 5 },
        (_, i) => dataPagination.totalPages - 4 + i
      ).forEach((i) => {
        buttons.push(
          <button
            key={i}
            data-testid={i}
            className={`tw-w-10 tw-h-10 ttw-focus:outline-none tw-focus:shadow-outline  tw-rounded-md ${
              dataPagination.currentPage === i
                ? 'tw-bg-[#FA6B25] tw-text-white'
                : 'tw-bg-white tw-text-blue-900'
            }`}
            onClick={() => dataPagination.handlePageClick(i)}
          >
            {i}
          </button>
        );
      });
    } else {
      buttons.push(<span key="ellipsis">...</span>);

      Array.from(
        { length: 5 },
        (_, index) => dataPagination.currentPage - 2 + index
      ).forEach((i) => {
        buttons.push(
          <button
            key={i}
            data-testid={i}
            className={`tw-w-10 tw-h-10 ttw-focus:outline-none tw-focus:shadow-outline  tw-rounded-md ${
              dataPagination.currentPage === i
                ? 'tw-bg-[#FA6B25] tw-text-white'
                : 'tw-bg-white tw-text-blue-900'
            }`}
            onClick={() => dataPagination.handlePageClick(i)}
          >
            {i}
          </button>
        );
      });

      buttons.push(<span key="ellipsis">...</span>);
    }
  }
  return buttons;
};
